<h3 class="mb-4" *ngIf="title">{{ title }}</h3>
<div>
  <p *ngIf="data.message" class="text-center my-4">
    {{ data.message }}
  </p>
  <input
    *ngIf="data.hasReason"
    type="text"
    class="base-text-input w-full"
    [maxLength]="maxLength"
    [placeholder]="placeholder || 'Reason'"
    [(ngModel)]="inputValue"
    name="input-dialog"
    (keyup)="handleKeyUp($event)"
  />
</div>
<div>
  <app-dialog-footer
    [isSaving]="isSaving"
    [loadingText]="'Saving...'"
    (cancelAction)="close()"
    (submitAction)="confirm()"
    [submitActionName]="'Confirm'"
    [valid]="getValid()"
  ></app-dialog-footer>
</div>
